import { all } from 'redux-saga/effects';

import { loginWatcher } from './redux/auth';

export default function* applicant() {
  yield all([loginWatcher()]);
}
